import { ExternalPaymentResponse, ICartCheckoutStatus } from '@core/interfaces/cart/cart-checkout-status.interface';
import { CheckoutStatus } from '@core/enums/cart/cart-checkout-status.enum';
import { CheckoutState } from '@core/enums/cart/cart-checkout-state.enum';
import { AAGUID, OnlinePaymentMethod } from '@interticket/core';
import { Customer } from '../customer/customer.model';

export class CartCheckoutStatus implements ICartCheckoutStatus {

  readonly cartId: AAGUID;
  readonly checkoutId: string;
  readonly customer: Customer;
  readonly externalPaymentId: AAGUID;
  readonly externalPaymentResponse: ExternalPaymentResponse;
  readonly paymentErrorMessage: string;
  readonly paymentMethodLabel: string;
  readonly paymentMethodType: OnlinePaymentMethod;
  readonly redirectParameter: any;
  readonly redirectUrl: string;
  readonly state: CheckoutState;
  readonly status: CheckoutStatus;
  readonly ticketDownloadLink: string;

  constructor(iCheckoutStatus: ICartCheckoutStatus) {
    this.cartId = iCheckoutStatus.cartId;
    this.checkoutId = iCheckoutStatus.checkoutId;
    this.customer = new Customer(iCheckoutStatus.customer);
    this.externalPaymentId = iCheckoutStatus.externalPaymentId;
    this.externalPaymentResponse = iCheckoutStatus.externalPaymentResponse;
    this.paymentErrorMessage = iCheckoutStatus.paymentErrorMessage;
    this.paymentMethodLabel = iCheckoutStatus.paymentMethodLabel;
    this.paymentMethodType = iCheckoutStatus.paymentMethodType;
    this.redirectParameter = iCheckoutStatus.redirectParameter;
    this.redirectUrl = iCheckoutStatus.redirectUrl;
    this.state = iCheckoutStatus.state;
    this.status = iCheckoutStatus.status;
    this.ticketDownloadLink = iCheckoutStatus.ticketDownloadLink;
  }

}
